export default "__VITE_ASSET__7JlGk80Q__"